export const WizardHowFeeling = {
  Good: 'good',
  Norm: 'norm',
  Difficult: 'difficult',
  Terrible: 'terrible'
}
